import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

/**
 *
 * @param {*} params
 * @returns {Promise<FetchRegionListResponse>}
 */
export function requestSalutationList(params) {
  return fetch.get(`${BASE_URL}/api/app/salutation`, {
    params: { limit: Number.MAX_SAFE_INTEGER },
  });
}
